import React from "react";
import Button from "react-bootstrap/Button";
import { useTranslation } from "react-i18next";
import { IoMdCheckboxOutline } from "react-icons/io";

const CreateModal = ({ title, text, onClose }) => {
  const { t } = useTranslation();
  const handleModalClose = () => {
    onClose();
  };

  return (
    <>
      <div className="popupBox p-3 p-md-5">
        <div>
          <div className="text-center mb-3 checkIcon">
            <IoMdCheckboxOutline onClick={handleModalClose} />
          </div>
          <div className="text-center mb-3 deleteHd">{title}</div>
          <div className="text-center mb-4">{text}</div>
          <div className="text-center">
            <Button className="smallBtn cancel me-3" onClick={handleModalClose}>
              {t("btns.close")}
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateModal;
